var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarCircleBottomUpBoldDuotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:circle-bottom-up-bold-duotone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.5,
    d: "M9 17C13.1422 17 16.5 13.6422 16.5 9.5C16.5 5.35775 13.1422 2 9 2C4.85775 2 1.5 5.35775 1.5 9.5C1.5 13.6422 4.85775 17 9 17Z",
    fill: "#3A849A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18763 10.25C3.18763 10.1008 3.24689 9.95774 3.35238 9.85225C3.45787 9.74676 3.60094 9.6875 3.75013 9.6875H8.25013C8.39931 9.6875 8.54239 9.74676 8.64788 9.85225C8.75337 9.95774 8.81263 10.1008 8.81263 10.25V14.75C8.81263 14.8992 8.75337 15.0423 8.64788 15.1477C8.54239 15.2532 8.39931 15.3125 8.25013 15.3125C8.10094 15.3125 7.95787 15.2532 7.85238 15.1477C7.74689 15.0423 7.68763 14.8992 7.68763 14.75V11.6075L2.64763 16.6475C2.541 16.7469 2.39996 16.801 2.25424 16.7984C2.10851 16.7958 1.96947 16.7368 1.86641 16.6337C1.76335 16.5307 1.70432 16.3916 1.70175 16.2459C1.69918 16.1002 1.75327 15.9591 1.85263 15.8525L6.89263 10.8125H3.75013C3.60094 10.8125 3.45787 10.7532 3.35238 10.6477C3.24689 10.5423 3.18763 10.3992 3.18763 10.25Z",
    fill: "#3A849A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarCircleBottomUpBoldDuotone);
export default __webpack_public_path__ + "static/media/solar_circle-bottom-up-bold-duotone.e38982b405bcdf2b484bab927b2d1a30.svg";
export { ForwardRef as ReactComponent };